import TextbookImage from "./TextbookImage";

export default TextbookImage;
